import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f4334fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "plot-dialog"
};
const _hoisted_2 = {
  class: "dialog-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tit"
}, "地块信息", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-back-icon"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-back-text"
}, "返回", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = {
  class: "dialog-content"
};
const _hoisted_8 = {
  class: "plot-content-left"
};
const _hoisted_9 = {
  class: "item-box"
};
const _hoisted_10 = {
  class: "item-box"
};
const _hoisted_11 = {
  class: "item-box"
};
const _hoisted_12 = {
  class: "soil"
};
const _hoisted_13 = {
  class: "greenhouse"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "plot-content-center"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "green_house"
})], -1));
const _hoisted_15 = {
  class: "plot-content-right"
};
const _hoisted_16 = {
  class: "item-box"
};
const _hoisted_17 = {
  class: "item-box"
};
const _hoisted_18 = {
  class: "item-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_plotInfo = _resolveComponent("plotInfo");
  const _component_borderBox2 = _resolveComponent("borderBox2");
  const _component_temperatureMonitoring = _resolveComponent("temperatureMonitoring");
  const _component_thresholdAlarm = _resolveComponent("thresholdAlarm");
  const _component_soilMoistureContent = _resolveComponent("soilMoistureContent");
  const _component_warmRegion = _resolveComponent("warmRegion");
  const _component_inputUsage = _resolveComponent("inputUsage");
  const _component_farmManagement = _resolveComponent("farmManagement");
  const _component_videoMonitoring = _resolveComponent("videoMonitoring");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_greenhouseDialog = _resolveComponent("greenhouseDialog");
  const _component_soilDialog = _resolveComponent("soilDialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.dialogVisible = $event),
    "before-close": $options.handleClose,
    "show-close": false,
    "align-center": false,
    onOpened: $options.openChange,
    "close-on-click-modal": true,
    modal: true,
    "destroy-on-close": true
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
      class: "dialog-back",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closeDialog && $options.closeDialog(...args))
    }, _hoisted_6)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_borderBox2, null, {
      title: _withCtx(() => [_createTextVNode("地块信息")]),
      body: _withCtx(() => [_createVNode(_component_plotInfo, {
        plotId: $data.plotId
      }, null, 8, ["plotId"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_borderBox2, null, {
      title: _withCtx(() => [_createTextVNode("空气温度监控")]),
      body: _withCtx(() => [_createVNode(_component_temperatureMonitoring, {
        plotId: $data.plotId,
        number: $data.number,
        ref: "temperatureMonitoring"
      }, null, 8, ["plotId", "number"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_borderBox2, null, {
      title: _withCtx(() => [_createTextVNode("阈值报警")]),
      body: _withCtx(() => [_createVNode(_component_thresholdAlarm, {
        plotId: $data.plotId
      }, null, 8, ["plotId"])]),
      _: 1
    })])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_soilMoistureContent, {
      onLookDetail: $options.lookDetail2
    }, null, 8, ["onLookDetail"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_warmRegion, {
      number: $data.number,
      onLookDetail: $options.lookDetail
    }, null, 8, ["number", "onLookDetail"])]), _hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_borderBox2, null, {
      title: _withCtx(() => [_createTextVNode("土壤温湿度")]),
      body: _withCtx(() => [_createVNode(_component_inputUsage, {
        ref: "inputUsage",
        plotId: $data.plotId,
        number: $data.number
      }, null, 8, ["plotId", "number"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_borderBox2, null, {
      title: _withCtx(() => [_createTextVNode("农事管理")]),
      body: _withCtx(() => [_createVNode(_component_farmManagement, {
        plotId: $data.plotId
      }, null, 8, ["plotId"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_borderBox2, null, {
      title: _withCtx(() => [_createTextVNode("视频监控")]),
      body: _withCtx(() => [_createVNode(_component_videoMonitoring, {
        ref: "videos"
      }, null, 512)]),
      _: 1
    })])])])]),
    _: 1
  }, 8, ["modelValue", "before-close", "onOpened"])]), _createVNode(_component_greenhouseDialog, {
    ref: "greenhouseDialog"
  }, null, 512), _createVNode(_component_soilDialog, {
    ref: "soilDialog"
  }, null, 512)], 64);
}